<template>
  <header class="appbar">
    <router-link to="/" class="vm-mark">
      <img
        class="vm-logo"
        src="../assets/images/logo-videomedi.png"
        alt="Videomedi"
      />
    </router-link>

    <div id="appbar-menu" class="appbar-menu" :class="{ 'is-open': menuOpen }">
      <nav class="appnav">
        <router-link to="/" exact active-class="is-active">Início</router-link>
        <router-link
          :to="{ path: '/', query: { buscar: '1' } }"
          active-class="is-active"
        >
          Buscar profissionais de saúde
        </router-link>
        <router-link v-if="loggedIn" to="/consultas" active-class="is-active">
          Minhas consultas
        </router-link>
        <router-link v-if="loggedIn" to="/documentos" active-class="is-active">
          Documentos
        </router-link>
        <router-link
          v-if="loggedIn"
          to="/meus-pagamentos"
          active-class="is-active"
        >
          Pagamentos
        </router-link>
      </nav>

      <span class="appbar-spacer" />

      <div v-if="!loggedIn" class="appbar-auth">
        <router-link to="/login" class="btn btn--ghost btn--sm">
          Entrar
        </router-link>
        <router-link to="/cadastrar" class="btn btn--outline btn--sm">
          Cadastrar
        </router-link>
      </div>
    </div>

    <template v-if="loggedIn">
      <!-- <router-link
        :to="{ path: '/', query: { buscar: '1' } }"
        class="btn btn--accent btn--sm"
      >
        Agendar consulta
      </router-link> -->
      <span class="appbar-icon" aria-label="Notificações">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path
            d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.3 21a1.94 1.94 0 0 0 3.4 0"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
        <!-- <span class="dot" /> -->
      </span>
      <AppBarUserMenu />
    </template>

    <button
      type="button"
      class="navbar-toggler appbar-toggler"
      :class="menuOpen ? 'not-collapsed' : 'collapsed'"
      aria-controls="appbar-menu"
      :aria-expanded="menuOpen ? 'true' : 'false'"
      :aria-label="menuOpen ? 'Fechar menu' : 'Abrir menu'"
      @click="menuOpen = !menuOpen"
    >
      <div class="animated-icon">
        <span />
        <span />
        <span />
        <span />
      </div>
    </button>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import AppBarUserMenu from "./AppBarUserMenu.vue";

export default {
  name: "AppBar",
  components: { AppBarUserMenu },
  data() {
    return {
      menuOpen: false
    };
  },
  computed: {
    ...mapGetters("auth", ["loggedIn"])
  },
  watch: {
    $route() {
      this.menuOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.appbar {
  display: flex;
  align-items: center;
  gap: var(--space-8);
  background: #fff;
  border-bottom: 1px solid var(--color-gray-200);
  padding: 0 var(--space-8);
  height: 68px;
  position: sticky;
  top: 0;
  z-index: 10;
}

.vm-mark {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  text-decoration: none;
  flex-shrink: 0;
}

.vm-logo {
  display: block;
  height: 28px;
  width: auto;
}

.appnav {
  display: flex;
  align-items: center;
  gap: var(--space-6);

  a {
    font-size: var(--font-size-sm);
    font-weight: var(--fw-semibold);
    color: var(--color-gray-600);
    text-decoration: none;
    white-space: nowrap;

    &:hover {
      color: var(--color-accent);
      text-decoration: none;
    }
    &.is-active {
      color: var(--color-accent);
    }
  }
}

.appbar-spacer {
  flex: 1;
}

.appbar-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-gray-500);
  cursor: pointer;
  flex-shrink: 0;
  position: relative;
  transition: background 0.12s, color 0.12s;

  &:hover {
    background: var(--color-gray-100);
    color: var(--color-gray-800);
  }

  .dot {
    position: absolute;
    top: 7px;
    right: 8px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--color-accent);
    border: 2px solid #fff;
  }
}

.appbar-menu {
  display: contents;
}

.appbar-auth {
  display: flex;
  align-items: center;
  gap: var(--space-8);
}

.appbar-toggler {
  display: none;

  .animated-icon span {
    background: var(--color-gray-600) !important;
  }
}

@media (max-width: 991px) {
  .appbar {
    gap: var(--space-4);
    padding: 0 var(--space-4);
  }

  .vm-mark {
    margin-right: auto;
  }

  .appbar-toggler {
    display: block;
  }

  .appbar-menu {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    flex-direction: column;
    gap: var(--space-4);
    padding: var(--space-4);
    background: #fff;
    border-bottom: 1px solid var(--color-gray-200);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.06);

    &.is-open {
      display: flex;
    }
  }

  .appnav {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-4);
  }

  .appbar-spacer {
    display: none;
  }

  .appbar-auth {
    flex-direction: column;
    align-items: stretch;
    gap: var(--space-2);

    .btn {
      justify-content: center;
    }
  }
}
</style>
